module.exports = __webpack_public_path__ + "img/gaming.ee07ab61.jpg";